var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card } from "./CardList/Card";
import Button from "./Semantic/Button";
import Modal from "./Semantic/Modal";
var CardModal = function (_a) {
    var card = _a.card, clearCard = _a.clearCard, guessCard = _a.guessCard;
    if (!card)
        return null;
    return (_jsxs(Modal, __assign({ onClose: clearCard, open: !!card, closeIcon: true, size: "mini" }, { children: [_jsx(Modal.Header, { children: card.name }, void 0), _jsx(Modal.Content, __assign({ style: { display: "flex", justifyContent: "center" } }, { children: _jsx(Card, { card: card }, void 0) }), void 0), _jsxs(Modal.Actions, { children: [_jsx(Button, __assign({ onClick: clearCard }, { children: "Cancel" }), void 0), _jsx(Button, { content: "Guess this card", labelPosition: "right", icon: "checkmark", onClick: guessCard, positive: true }, void 0)] }, void 0)] }), void 0));
};
export default CardModal;
